export default __webpack_public_path__ + "static/media/seema kanani.2d4fa3e8.jpg";